import api from '@/api';

/*
 * The power-loss tool's total, worked out from the server in one go.
 *
 * Every tool screen used to add its own total to the other three it found in the store
 * (P_Busbar, P_InputCircuit, P_OutputCircuit, P_ManuelCircuit) - values the other screens had
 * written, and not all of them right: the output circuits wrote theirs without the
 * circuit-count factor, Manuel wrote its last row instead of its sum, and wrote it as a
 * string, so the next screen's "+" turned the total into concatenated text. Only the summary
 * screen summed correctly, and only if the user went through it.
 *
 * These are the summary's figures: busbars, input devices + input conductors, output
 * circuits with the factor and sub-distribution busbars (GetAllTotal_P_OutputCircuit[1]),
 * and the additional powers.
 */
export function fetchLossTotals(projectId) {
    const value = (res) => {
        if (!res || res.isError) {
            throw res || new Error('No answer');
        }
        return parseFloat(res.data) || 0;
    };

    return Promise.all([
        api.panels.getTotal_P_BusbarCalculationDevices(projectId),
        api.panels.getTotal_P_InputCircuitCalculationDevices(projectId),
        api.panels.getTotal_P_InputCircuitDeviceConductors(projectId),
        api.panels.getAllTotal_P_OutputCircuit(projectId),
        api.panels.getTotal_P_OtherPowerCalculationDevices(projectId)
    ]).then(([busbar, inputDevices, inputConductors, output, manuel]) => {
        if (!output || output.isError) {
            throw output || new Error('No answer');
        }
        const totals = {
            busbar: value(busbar),
            input: value(inputDevices) + value(inputConductors),
            output: (output.data && parseFloat(output.data[1])) || 0,
            manuel: value(manuel)
        };
        totals.total = totals.busbar + totals.input + totals.output + totals.manuel;
        return totals;
    });
}

/* Fetches the totals and writes them, as numbers, where the results step reads them. */
export function storeLossTotals(store, projectId) {
    return fetchLossTotals(projectId).then((totals) => {
        store.commit('setLossTotals', totals);
        return totals;
    });
}
